import { InteractionType, EventSource, MixpanelEvent, ComponentType } from '../MixPanelTypes';

export type ExpenseHubEvents = 'EXPORT_RESULT' | 'FILTER_ONLY_UNEXPORTED';

export const expenseHub: Record<ExpenseHubEvents, MixpanelEvent> = {
  EXPORT_RESULT: {
    eventDescription: 'Export Expense Result',
    eventKey: 'export-expense-result ',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  FILTER_ONLY_UNEXPORTED: {
    eventDescription: 'Usage of "Only Unexported" filter',
    eventKey: 'expense-table-filter-only-unexported',
    eventSource: EventSource.USER_EFFECT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.DATA_TABLE
  }
};
